import type { Hotel_HotelInfoSettingsPageQuery } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { HotelInfoZodSchemaType } from "./validation-schema";

const _excludeKeys = ["companyID", "hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type HotelSettingsHotelInfoFormModel = AutoGeneratorForFormModel<
	HotelInfoZodSchemaType, //
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;

export type ServerModel = Hotel_HotelInfoSettingsPageQuery;
